const EARN_CATEGORY = 'earn'

export const EARN_EVENTS = {
  OPEN_EARN_PAGE: {
    action: 'Open earn page',
    category: EARN_CATEGORY,
  },
  HIDE_EARN_BANNER: {
    action: 'Hide earn banner',
    category: EARN_CATEGORY,
  },
  GET_STARTED_WITH_EARN: {
    action: 'Get started with earn',
    category: EARN_CATEGORY,
  },
  OPEN_EARN_LEARN_MORE: {
    action: 'Open earn learn more',
    category: EARN_CATEGORY,
  },
}

export enum EARN_LABELS {
  safe_dashboard_banner = 'safe_dashboard_banner',
  sidebar = 'sidebar',
  info_banner = 'info_banner',
}
